import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PageContentDirective, PageFooterDirective, PageHeaderDirective } from './directives';
import { PageComponent } from './page.component';

const PUBLIC = [
  PageComponent,
  PageHeaderDirective,
  PageContentDirective,
  PageFooterDirective
];

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: PUBLIC,
  exports: PUBLIC,
})
export class PageModule { }
